export enum OpenCabUsersActionTypes {
    SET_OPENCABUSER = "SET_OPENCABUSER",
    CLEAR_OPENCABUSER = "CLEAR_OPENCABUSER"
}